import { Resource as a, API as i } from "@coveo/platform-client";
const t = class t extends a {
  list(e) {
    return this.api.get(this.buildPath(`${t.baseUrl}`, e));
  }
  get(e) {
    return this.api.get(`${t.baseUrl}/${e}`);
  }
  create(e) {
    return this.api.post(`${t.baseUrl}`, e);
  }
  update(e, s) {
    return this.api.put(`${t.baseUrl}/${e}`, s);
  }
  delete(e) {
    return this.api.delete(`${t.baseUrl}/${e}`);
  }
  copy(e) {
    return this.api.post(`${t.baseUrl}/copy`, e);
  }
  validateCopyRulesToTrackingId(e) {
    return this.api.post(`${t.baseUrl}/copy/validate`, e);
  }
};
t.baseUrl = `/rest/organizations/${i.orgPlaceholder}/commerce/private/rules`;
let r = t;
export {
  r as RuleDefinition
};
//# sourceMappingURL=RuleDefinition.js.map
